const Navbar = () => (
  <>
    <nav class="block w-full max-w-screen-lg px-4 py-2 mx-auto backdrop-filter backdrop-blur-md bg-[#09090B] bg-opacity-80 sticky top-3 shadow-2xl lg:px-8 lg:py-3  backdrop-saturate-200 z-[9999] rounded-full">
      <div class="container flex flex-wrap items-center justify-center mx-auto ">
        <h1 class="mr-4 block text-2xl sm:text-4xl cursor-pointer py-1.5  text-[#f2932c] font-bold font-serif italic ">
          Samir Gallery
        </h1>
      </div>
    </nav>
  </>
);

export default Navbar;
